import { UUID } from "../../utils/typeDefinitions"
import Document from "./Document"
import ProjectDocument from "./ProjectDocument"

class ApartmentDocument extends ProjectDocument {
    apartmentUuid: UUID
    
    constructor(projectUuid: UUID, apartmentUuid: UUID, document: Document, version: number = 1) {
        super(projectUuid, document, version);
        this.apartmentUuid = apartmentUuid
    }
    
    toJson(): any {
    
        return {
            ...super.toJson(),
            apartmentId: this.apartmentUuid
        };
    }
    
    static fromJson(json: any): ApartmentDocument {
        return new ApartmentDocument(
            json.projectId,
            json.apartmentId,
            Document.fromJson(json.document),
            json.version || 1
        );
    }

    getEntityId(): UUID {
        return this.apartmentUuid;
    }

}

export default ApartmentDocument;